import { type JSX, Show } from "solid-js";

export function ScanRouteHeader(props: {
  websiteId: string;
  section: string;
  title: string;
  subtitle: string;
  actions?: JSX.Element;
}) {
  return (
    <header class="signal-route-header">
      <div class="signal-page-head signal-page-head-compact">
        <div>
          <Show when={props.section !== props.title}>
            <span class="signal-mini-kicker">{props.section}</span>
          </Show>
          <h1>{props.title}</h1>
          <p>{props.subtitle}</p>
        </div>
        {props.actions}
      </div>
    </header>
  );
}
